<template>
    <div v-if="info.chemistrydesc">
      <div style="width: 95.4%;margin:0 auto;padding-left: 4%;">
          <div style="background-color: #DC143C;color:#FFF;font-weight: bold;display: table;padding:4px 0">&nbsp;宁夏建龙电子标牌-申银牌&nbsp;</div>
          <div class="content">
              <div class="title">产品信息</div>
              <div style="background-color: #F5F5F5;">
                  <div id="name" @click="getRow(0)" :style="{
                              'background':actRow == 0 ? 'rgb(208,219,252)' : 'none'
                              }">&nbsp;&nbsp;品&nbsp;&nbsp;名：{{info.name}}</div>
                  <div style="display: flex;">
                      <div style="width:50%"  class="proInfo">
                          <div @click="getRow(1)" 
                          :style="{
                              'background':actRow == 1 ? 'rgb(208,219,252)' : 'none'
                              }">&nbsp;&nbsp;标&nbsp;&nbsp;准：{{info.standards}}</div>
                          <div @click="getRow(2)" :style="{
                              'background':actRow == 2 ? 'rgb(208,219,252)' : 'none'
                              }">&nbsp;&nbsp;牌&nbsp;&nbsp;号：{{info.brand}}</div>
                          <div @click="getRow(3)" :style="{
                              'background':actRow == 3 ? 'rgb(208,219,252)' : 'none'
                              }">&nbsp;&nbsp;批&nbsp;&nbsp;号：{{info.batch}}</div>
                          <div @click="getRow(4)" :style="{
                              'background':actRow == 4 ? 'rgb(208,219,252)' : 'none'
                              }">&nbsp;&nbsp;重&nbsp;&nbsp;量：{{info.weight}}</div>
                      </div>
                      <div style="width:50%" class="proInfo">
                          <div @click="getRow(1)" :style="{
                              'background':actRow == 1 ? 'rgb(208,219,252)' : 'none'
                              }">日&nbsp;&nbsp;期：{{info.date}}</div>
                          <div @click="getRow(2)" :style="{
                              'background':actRow == 2 ? 'rgb(208,219,252)' : 'none'
                              }">规&nbsp;&nbsp;格：{{info.specifications}}</div>
                          <div @click="getRow(3)" :style="{
                              'background':actRow == 3 ? 'rgb(208,219,252)' : 'none'
                              }">序&nbsp;&nbsp;号：{{info.number}}</div>
                          <div @click="getRow(4)" :style="{
                              'background':actRow == 4 ? 'rgb(208,219,252)' : 'none'
                              }">支&nbsp;&nbsp;数：{{info.count}}</div>
                      </div>
                  </div>
              </div>
              <div class="title">成分信息</div>
              <div  v-html="info.chemistrydesc" class="chemistry-table" @click="getRow(null)"></div>
              <div class="title">物理性能</div>
              <div  v-html="info.physicsdesc" class="chemistry-table"  @click="getRow(null)"> </div>
          </div>
         
      </div>
      <!-- <div style="display: flex;flex-direction: row-reverse;" v-if="info.images"> 
          <img v-for="(item,index) in info.images.split(',')" :key="index" :src="item" style="width: 20%;margin-right: 10px;">
      </div> -->
    </div>
  </template>
  
  <script>
  
  ////用于页面最大化
  function setSize() {
  
  var myHeight = 200;     //窗口高度
  var myWidth = 400;     //窗口宽度
  window.resizeTo(myWidth, myHeight);
  window.moveTo((window.screen.availWidth - myWidth) / 2, (window.screen.availHeight - myHeight) / 2);
  }
  
  export default {
      data(){
          return{
              actRow:null,
          }
      },
      props:['info'],
      created(){},
      mounted(){
          setSize()
      },
      methods:{
          getRow(row){
              this.actRow = row
          }
      },
      beforeDestroy() {}
  }
  </script>
  
  <style scoped>
  *{
      font-family: "黑体";
  }
      .title{
          background: #DCDCDC;
          margin-top: 2px;
          padding:4px 0;
          font-weight: bold;
          font-size: 0.95rem;
      }
      .content{
          line-height: 1.6rem;
          font-size: 0.8rem;
  
      }
      .chemistry-table{
          background: #f5f5f5;
      }
      /deep/ .chemistry-table table{
          border:0.5px solid #ccc;
          border-collapse: collapse;
      }
      /deep/ .chemistry-table th{
          border-spacing: 0;
          
          border-collapse: collapse;
          background:  #DCDCDC ;
          border-right:0.5px solid #ccc;
  
      }
      /deep/ .chemistry-table td{
          border-right:0.5px solid #ccc;
  
      }
     /deep/ tr:hover{
          background:rgb(208,219,252)
      }
      /* #name:hover{
          background:rgb(208,219,252)
  
      } */
  </style>


// WEBPACK FOOTER //
// src/components/man8/mp.vue